export default __webpack_public_path__ + "static/media/OrderUpdates.b039263d.svg";